import styled from 'styled-components';
import {GoogleOAuthProvider} from '@react-oauth/google';

import {getLocalizationService} from '~/shared/services/localisationService';
import {googleLoginClientKey, isJustEat} from '~/shared/config';

import {LoginWithSectionHeader} from '../loginStyled';

import GoogleSection, {GoogleSectionProps} from './GoogleSection';
import FacebookSection, {FacebookSectionProps} from './FacebookSection';

const Root = styled.div``;

const OAuthSectionButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface OAtuhSectionProps {
  openFacebook: FacebookSectionProps['onClick'];
  onSubmitWithGoogleConnect: GoogleSectionProps['onSubmit'];
  openProviderScreen: GoogleSectionProps['openProviderScreen'];
  openLoginScreen?: GoogleSectionProps['openLoginScreen'];
  isRedirectedToStepRef: GoogleSectionProps['isRedirectedToStepRef'];
  fromCheckout?: GoogleSectionProps['fromCheckout'];
  isRegistration?: GoogleSectionProps['isRegistration'];
}

const OAuthSection = ({openFacebook, onSubmitWithGoogleConnect, openProviderScreen, openLoginScreen, isRedirectedToStepRef, fromCheckout, isRegistration}: OAtuhSectionProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      {(googleLoginClientKey || !isJustEat) && (
        <>
          <LoginWithSectionHeader>{t('or')}</LoginWithSectionHeader>
          <OAuthSectionButtonsWrapper>
            {googleLoginClientKey && (
              <GoogleOAuthProvider clientId={googleLoginClientKey}>
                <GoogleSection
                  openLoginScreen={openLoginScreen}
                  openProviderScreen={openProviderScreen}
                  onSubmit={onSubmitWithGoogleConnect}
                  isRedirectedToStepRef={isRedirectedToStepRef}
                  fromCheckout={fromCheckout}
                  isRegistration={isRegistration}
                />
              </GoogleOAuthProvider>
            )}
            {!isJustEat && <FacebookSection onClick={openFacebook} />}
          </OAuthSectionButtonsWrapper>
        </>
      )}
    </Root>
  );
};

export default OAuthSection;
